import { demoFile, component, feature } from 'system/demo';
import { PrivateThankYouMessage, PrivateCommentFeedbackFeature } from '../private-comment-feedback';
import { SimpleCommentsStructure } from 'structure/simple-comments';
import React from 'react';

demoFile('open-modules/zdf/feature/private-comment-feedback');

function PrivateThankYouMessageDemo() {
    const comment = {
        key: 'c1',
        from: 'u1',
        text: '!Nice answer',
        deservesPositiveFeedback: true,
        thankYouText: '!Here you go, you deserve this cookie: 🍪'
    };
    return <PrivateThankYouMessage comment={comment} showAuthor />;
}

component('PrivateThankYouMessage', PrivateThankYouMessageDemo, {
    structureKey: 'simplecomments',
    state: { personaKey: 'u1', language: 'english' }
});

feature('Private Comment Feedback', {
    structureKey: 'simplecomments',
    config: SimpleCommentsStructure.receivesConfigDefaults,
    state: {
        globals: { name: '!Question' },
        collections: {
            comment: [
                { key: 'c1', from: 'u1', text: '!Nice answer', deservesPositiveFeedback: true, thankYouText: '!Here you go, you deserve this cookie: 🍪' }
            ],
            thought_provoking_prompt: [
                { key: 't1', suggestedPerspective: '!Be kind', reminder: '!Be respectful', time: 0 }
            ]
        },
        roles: ['Moderator'],
        language: 'english'
    },
    features: { conversationhelper: true, privatecommentfeedback: true }
});
